import "./Label.scss";
import React from "react";
export const Label = ({ className, labelData, isAdaptive = true, size }) => {
    const { color, text } = labelData;
    return labelData ? (React.createElement("div", { className: "label" +
            (className ? ` ${className}` : "") +
            (size === "small" ? " label_small" : "") +
            (isAdaptive && !size ? " label_adaptive" : ""), style: { backgroundColor: color } },
        React.createElement("span", null, text))) : null;
};
